// extracted by mini-css-extract-plugin
module.exports = {"acpInvoiceCard":"index_acpInvoiceCard__1brcx"};